import React from 'react';
import { Button } from "react-bootstrap";
import FontAwesome from "react-fontawesome";
import { addTypeDescription } from "../constants/messages";

const AddButton = ({
  onClickAddFunction,
  addType
}) => /*#__PURE__*/React.createElement(Button, {
  variant: "success",
  title: `Add a new ${addTypeDescription(addType)}`,
  onClick: () => onClickAddFunction(addType)
}, /*#__PURE__*/React.createElement(FontAwesome, {
  name: "plus"
}), "\xA0Add");

export default AddButton;